import { useAuth } from '../../../../hooks/useAuth';
import { MouseEvent, useCallback, useState } from 'react';
import FallbackSpinner from '../../../../materio/@core/components/spinner';
import ReactFlow, { Background, BackgroundVariant, OnConnectEnd, useReactFlow, } from 'reactflow';
import 'reactflow/dist/style.css';
import { useRef } from 'react';
import './node-designer.css';
import useChats from '../../hooks/useChats';
import useDesigner from '../../hooks/useDesigner';
import ContextMenu from './ContextMenu';
import { designerConfig } from '../../config/config-designer';

const rfStyle = {
    backgroundColor: '#B8CEFF',
};

type MenuContext = {
    id: string,
    top: number | undefined,
    left: number | undefined,
    position: 'fixed' | 'relative' | 'absolute',
    clientX: number,
    clientY: number
}


type Props = {
    onClose: () => void
}

const Designer = ({ onClose }: Props) => {
    const [menu, setMenu] = useState<MenuContext>({
        top: -200,
        left: -200,
        id: '',
        position: 'fixed',
        clientX: 0,
        clientY: 0
    });

    const { chat } = useChats();

    const reactFlowWrapper = useRef(null);


    const { onConnect, onConnectEnd, onEdgesChange, onConnectStart, onNodesChange, createNode } = useDesigner();
    const { user } = useAuth();
    const reactFlowRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);

    if (!user) return <FallbackSpinner />

    //const onContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    //    if (!ref.current) return null;

    //    const pane = ref.current.getBoundingClientRect();

    //    setContextMenuState({
    //        ...contextMenuState,
    //        open: true,
    //        top: event.clientY < pane.height - 200 && event.clientY,
    //        left: event.clientX < pane.width - 200 && event.clientX,
    //    })

    //    e.preventDefault();
    //    return false;
    //}

    const onContextMenu = (event: MouseEvent<HTMLDivElement>) => {
        if (!reactFlowRef.current || !menuRef.current) return null;

        const pane = reactFlowRef.current.getBoundingClientRect();

        event.preventDefault();

        // Calculate position of the context menu. We want to make sure it
        // doesn't get positioned off-screen.

        console.log(menuRef);

        // Mouse position
        const x = event.clientX - pane.left;
        const y = event.clientY - pane.top;

        const top = y < pane.height - menuRef.current?.clientHeight ? y : y - menuRef.current?.clientHeight;
        const left = x < pane.width - menuRef.current?.clientWidth ? x : x - menuRef.current?.clientWidth;

        setMenu({
            id: '',
            top: top,
            left: left,
            position: 'absolute',
            clientX: event.clientX,
            clientY: event.clientY
        });

    }

    // Close the context menu if it's open whenever the window is clicked.
    const onPaneClick = () => setMenu({
        top: -2000,
        left: -2000,
        id: '',
        position: 'fixed',
        clientX: 0,
        clientY: 0
    })

    return (

        <div className="wrapper" ref={reactFlowWrapper} style={{ width: '100%', position: 'relative' }} onContextMenu={onContextMenu}>
            <ReactFlow
                ref={reactFlowRef}
                nodes={chat.nodes}
                edges={chat.edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                onConnectStart={onConnectStart}
                onConnectEnd={onConnectEnd}
                fitView
                nodeTypes={designerConfig.nodeTypes}
                fitViewOptions={{ padding: 2 }}
                nodeOrigin={[0.5, 0]}
                onContextMenu={onContextMenu}
                onPaneClick={onPaneClick}
            >
                <Background color="#ccc" variant={BackgroundVariant.Dots} />
            </ReactFlow>

            <ContextMenu
                {...menu}
                ref={menuRef}
                createNode={createNode}
                onClose={onPaneClick}
            />
        </div>
    )
}

export default Designer;
